// Labels legíveis para os enums de modelo do painel Windx (WINDX-063).
// Evita exibir valores crus (`curto_prazo`, `sh`) na tabela admin.

import { WindxCategoria, WindxTela } from 'types/Windx/Models/windxPainelOption';

export const CATEGORIA_LABELS: Record<WindxCategoria, string> = {
  curto_prazo: 'Curto Prazo',
  climatologia: 'Climatologia',
  anos_historicos: 'Anos Históricos',
  medio_prazo: 'Médio Prazo',
};

export const categoriaLabel = (categoria: WindxCategoria | null): string => (
  categoria ? CATEGORIA_LABELS[categoria] : '—'
);

export const telasLabel = (telas: WindxTela[]): string => (
  telas.map((tela) => tela.toUpperCase()).join(', ')
);
